/* Seyasha sign-up offer: pop-up, sign-up tagging, welcome note. Settings come from #sy-su-cfg (sections/sy-signup.liquid).
   Nothing here can grant a discount: every code is a Shopify discount limited to a customer segment, checked at checkout. */
(function () {
  'use strict';
  var D = document, W = window;
  var cfgEl = D.getElementById('sy-su-cfg');
  if (!cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  var KEY = 'sy-su', SKEY = 'sy-su-s';
  var RESERVED = (cfg.reserved || []).map(function (c) { return String(c).toUpperCase(); });

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function sess(v) { try { if (v) sessionStorage.setItem(SKEY, '1'); return !!sessionStorage.getItem(SKEY); } catch (e) { return false; } }

  /* ---------- the code a first name turns into (Shopify Flow reads it from the sy-code- tag) ---------- */
  function codeBase(first) {
    var s = String(first || '');
    /* strip accents (e acute -> e); the range is built from char codes so the file stays plain ASCII */
    if (s.normalize) s = s.normalize('NFD').replace(new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g'), '');
    s = s.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 12);
    if (s.length < 3) return '';
    if (RESERVED.indexOf(s) > -1 || RESERVED.indexOf(s + '2') > -1 || RESERVED.indexOf(s + '3') > -1) s += 'SY';
    return s;
  }
  function analyticsOK() {
    var cp = W.Shopify && Shopify.customerPrivacy;
    try { return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()); } catch (e) { return false; }
  }
  function tagsFor(form) {
    var t = ['sy-signup'];
    var fn = form.querySelector('[name="customer[first_name]"]');
    var b = codeBase(fn && fn.value);
    /* sy-name tells the Flow workflow there is a first-name code to make */
    if (b) t.push('sy-name', 'sy-code-' + b);
    var f = form.querySelector('input[name="sy_for"]:checked');
    if (f) t.push(f.value === 'both' ? 'shop-both' : 'shop-' + f.value);
    var em = form.querySelector('[name="customer[email]"]');
    var dom = ((em && em.value) || '').toLowerCase().split('@')[1] || '';
    if (/\.(ac\.in|edu|edu\.in)$/.test(dom)) t.push('life-student');
    /* what they browsed, only when they allowed analytics cookies */
    if (analyticsOK() && W.SYM && typeof SYM.profile === 'function') {
      try {
        var p = SYM.profile() || {};
        if (p.persona && /^[a-z]+$/.test(p.persona)) t.push('persona-' + p.persona);
        if ((p.life === 'student' || p.life === 'pro') && t.indexOf('life-student') < 0) t.push('life-' + p.life);
        if (!f && (p.forWho === 'him' || p.forWho === 'her')) t.push('shop-' + p.forWho);
      } catch (e) {}
    }
    return t.join(', ');
  }
  function backTo() {
    var u = location.pathname + location.search.replace(/([?&])sy_su=1(&|$)/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'sy_su=1';
  }

  /* ---------- checks before sending ---------- */
  function fail(form, input, msg) {
    var err = form.querySelector('[data-sy-su-err]');
    if (err) { err.textContent = msg; err.hidden = false; }
    if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    return false;
  }
  function checkSignup(form) {
    $$('[aria-invalid]', form).forEach(function (i) { i.removeAttribute('aria-invalid'); });
    var err = form.querySelector('[data-sy-su-err]');
    if (err) err.hidden = true;
    var fn = form.querySelector('[name="customer[first_name]"]');
    var tel = form.querySelector('[name="customer[note][Mobile]"]');
    var em = form.querySelector('[name="customer[email]"]');
    var pw = form.querySelector('[name="customer[password]"]');
    if (fn && !fn.value.trim()) return fail(form, fn, 'Enter your first name.');
    if (tel && !/^[6-9][0-9]{9}$/.test(tel.value)) return fail(form, tel, 'Enter a valid 10-digit mobile number.');
    if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())) return fail(form, em, 'Enter a valid email address.');
    if (pw && pw.value.length < 5) return fail(form, pw, 'Use at least 5 characters for your password.');
    return true;
  }
  function checkLogin(form) {
    var err = form.querySelector('[data-sy-su-err]');
    if (err) err.hidden = true;
    var em = form.querySelector('[name="customer[email]"]'), pw = form.querySelector('[name="customer[password]"]');
    if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim())) return fail(form, em, 'Enter the email you signed up with.');
    if (pw && !pw.value) return fail(form, pw, 'Enter your password.');
    return true;
  }

  /* any create_customer form with the marker (pop-up and the register page) gets the sign-up tags */
  function wireSignup(form) {
    if (form.__sySu) return;
    form.__sySu = 1;
    var tel = form.querySelector('[name="customer[note][Mobile]"]');
    if (tel) tel.addEventListener('input', function () { var v = tel.value.replace(/[^0-9]/g, '').slice(0, 10); if (v !== tel.value) tel.value = v; });
    form.addEventListener('submit', function (e) {
      var popup = !!form.closest('[data-sy-su]');
      if (popup && !checkSignup(form)) { e.preventDefault(); return; }
      if (e.defaultPrevented) return;
      var tg = form.querySelector('[data-sy-su-tags]');
      if (!tg) { tg = D.createElement('input'); tg.type = 'hidden'; tg.name = 'customer[tags]'; form.appendChild(tg); }
      tg.value = tagsFor(form);
      var ph = form.querySelector('[data-sy-su-phone]');
      if (ph && tel && /^[6-9][0-9]{9}$/.test(tel.value)) { ph.value = '+91' + tel.value; ph.disabled = false; }
      var ret = form.querySelector('[data-sy-su-ret]');
      if (ret) ret.value = backTo();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
      var st = read(); st.done = Date.now(); write(st);
    });
  }
  $$('input[data-sy-su-mark]').forEach(function (m) { if (m.form) wireSignup(m.form); });

  /* ---------- welcome note after signing up or in ---------- */
  function money(n) { var c = (cfg.money || [])[0] || ''; return c.replace(/[0-9][0-9,.]*/, String(n)); }
  function welcome() {
    if (!cfg.in || !/[?&]sy_su=1(&|$)/.test(location.search)) return;
    try { history.replaceState(history.state, '', location.pathname + location.search.replace(/([?&])sy_su=1(&|$)/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {}
    var data = {};
    try { data = JSON.parse((D.getElementById('sy-coupons') || {}).textContent || '{}'); } catch (e) {}
    var mine = (data.coupons || []).filter(function (c) { return c.personal; })[0];
    if (!mine) return;
    var nth = mine.stage === 1 ? 'first' : mine.stage === 2 ? 'second' : 'third';
    var box = D.createElement('div');
    box.className = 'sy-su-hi';
    box.setAttribute('role', 'status');
    box.innerHTML = '<p class="sy-su-hi__t"></p><div class="sy-su-hi__row"><b class="sy-su-hi__c"></b><button type="button" class="sy-su-hi__copy">Copy</button></div>' +
      '<p class="sy-su-hi__n">Use it in your bag or at checkout, on a prepaid order.' + (cfg.names && mine.stage === 1 ? ' A new code can take a minute to start working.' : '') + '</p>' +
      '<button type="button" class="sy-su-hi__x" aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
    box.querySelector('.sy-su-hi__t').textContent = (cfg.name ? 'Welcome, ' + cfg.name + '! ' : 'Welcome! ') + 'Your ' + nth + '-order code takes ' + money(mine.value) + ' off.';
    box.querySelector('.sy-su-hi__c').textContent = mine.code;
    var copy = box.querySelector('.sy-su-hi__copy');
    copy.addEventListener('click', function () {
      var done = function () { copy.textContent = 'Copied'; };
      try { navigator.clipboard.writeText(mine.code).then(done, done); } catch (e) { done(); }
    });
    var close = function () { box.classList.remove('is-on'); setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 400); };
    box.querySelector('.sy-su-hi__x').addEventListener('click', close);
    D.body.appendChild(box);
    requestAnimationFrame(function () { box.classList.add('is-on'); });
    setTimeout(close, 15000);
  }

  /* ---------- the sign-up line under the size buttons (snippets/sy-su-line.liquid) ---------- */
  $$('[data-sy-su-line]').forEach(function (l) {
    if (!$('[data-sy-su]') || !cfg.teaser) { if (l.parentNode) l.parentNode.removeChild(l); return; }
    var t = l.querySelector('[data-sy-su-line-t]');
    if (t) t.textContent = cfg.teaser;
  });

  /* ---------- the pop-up ---------- */
  var pop = $('[data-sy-su]');
  if (!pop || cfg.in) { welcome(); return; }
  var box = $('.sy-su__box', pop), codeEl = $('[data-sy-su-code]', pop), fnIn = $('#SySu-fn', pop);
  var lastFocus = null, isOpen = false, auto = false;

  function paintCode() {
    if (!codeEl) return;
    var b = cfg.names ? codeBase(fnIn && fnIn.value) : '';
    codeEl.textContent = b || (cfg.names && !(fnIn && fnIn.value.trim()) ? 'YOURNAME' : (cfg.codes || [])[0] || '');
  }
  if (fnIn) fnIn.addEventListener('input', paintCode);
  paintCode();

  function tab(n) {
    $$('[data-sy-su-tab]', pop).forEach(function (t) {
      var on = t.getAttribute('data-sy-su-tab') === String(n);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = D.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }
  function focusables() {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])', box)
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function open(how) {
    if (isOpen) return;
    isOpen = true;
    auto = how === 'auto';
    lastFocus = D.activeElement;
    pop.hidden = false;
    D.documentElement.classList.add('sy-su-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
    sess(true);
    var st = read(); st.n = (st.n || 0) + 1; st.last = Date.now(); write(st);
    /* opening on its own must not pop the phone keyboard, so focus the dialog itself */
    setTimeout(function () { (how === 'auto' ? box : (fnIn || box)).focus({ preventScroll: true }); }, 60);
    try { W.dispatchEvent(new CustomEvent('sy:signup-open', { detail: { how: how } })); } catch (e) {}
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    pop.classList.remove('is-open');
    D.documentElement.classList.remove('sy-su-lock');
    var st = read(); st.d = Date.now(); write(st);
    setTimeout(function () { pop.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  W.SySignup = { open: function () { open('click'); }, close: close, code: codeBase };

  pop.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-sy-su-close]')) { close(); return; }
    var tb = t.closest('[data-sy-su-tab]');
    if (tb) { tab(tb.getAttribute('data-sy-su-tab')); return; }
    var pw = t.closest('[data-sy-su-pw]');
    if (pw) {
      var inp = D.getElementById(pw.getAttribute('aria-controls'));
      if (!inp) return;
      var show = inp.type === 'password';
      inp.type = show ? 'text' : 'password';
      pw.textContent = show ? 'Hide' : 'Show';
      pw.setAttribute('aria-pressed', show ? 'true' : 'false');
    }
  });
  pop.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      var tb = e.target.closest && e.target.closest('[data-sy-su-tab]');
      if (tb) { var n = tb.getAttribute('data-sy-su-tab') === '1' ? 2 : 1; tab(n); var nt = $('[data-sy-su-tab="' + n + '"]', pop); if (nt) nt.focus(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (D.activeElement === first || D.activeElement === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  var login = $('#SySu-login', pop);
  if (login) login.addEventListener('submit', function (e) {
    if (!checkLogin(login)) { e.preventDefault(); return; }
    var ret = login.querySelector('[data-sy-su-ret]');
    if (ret) ret.value = backTo();
  });

  /* "sign up" lines under the offers, and any link with data-sy-su-open */
  D.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-sy-su-open]') : null;
    if (!t) return;
    e.preventDefault();
    tab(t.getAttribute('data-sy-su-open') === 'login' ? 2 : 1);
    open('click');
  });

  /* ---------- opening on its own ---------- */
  function allowedNow() {
    if (!cfg.auto || isOpen) return false;
    var st = read();
    if (st.done) return false;
    if (st.d && Date.now() - st.d < (cfg.days || 3) * 864e5) return false;
    if (sess()) return false;
    return true;
  }
  function busy() {
    /* the cookie banner, an open drawer or menu, or someone typing: wait */
    var cp = W.Shopify && Shopify.customerPrivacy;
    try { if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return true; } catch (e) {}
    var bn = D.getElementById('shopify-pc__banner');
    if (bn && bn.offsetParent !== null) return true;
    if (D.querySelector('cart-drawer.active, .drawer.active, details.menu-drawer-container[open], details-modal details[open], quick-add-modal[open], product-modal[open], .sy-qa-open')) return true;
    var a = D.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    if (D.hidden) return true;
    return false;
  }
  if (allowedNow()) {
    var tries = 0;
    var go = function () {
      if (!allowedNow()) return;
      if (busy()) { if (++tries < 24) setTimeout(go, 5000); return; }
      open('auto');
    };
    setTimeout(go, Math.max(3, +cfg.delay || 8) * 1000);
  }
})();
